module.exports = __webpack_public_path__ + "assets/floor2.png?fc0be1469390850a75eca79e5ee3d47a";